module.exports = __webpack_public_path__ + "img/email.f58bb455.svg";